import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import Actions from "../../../../layouts/Actions";
import UserContext from "../../../../context/UserContext/UserContext";
import CustomerContext from "../../../../context/CustomerContext/CustomerContext";
import {
  DELETE_Customer,
  Enable_Disable_Customer,
  Get_Details_Customer,
} from "../../../../Apis/customerApi/customerApi";

const CustomerDataTableContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setDialogs,
    setOrgId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(CustomerContext);
  const { orgDetails } = useContext(UserContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get Customer Details
   */
  const { mutate: customerDetails, isLoading: isLoadingCompanyDetails } =
    useMutation((customerId) =>
      Get_Details_Customer(customerId, setFormData, setDialogs)
    );

  const GetCompanyDetails = (customerId) => {
    customerDetails(customerId);
    setOrgId(customerId);
    setIsEdit(false);
  };

  /**
   * delete Customer
   */
  const { mutate: customerDelete, isLoading: isLoadingDelete } = useMutation(
    (customerId) => DELETE_Customer(customerId, refetch)
  );

  const DeleteCompany = async (customerId) => {
    SweetConfirmation(customerDelete, customerId);
  };

  /**
   * enable / disable Customer
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Customer(formData, refetch)
  );

  const handleCustomerStatusChange = (customerId, status) => {
    let formDate = {
      customerId: customerId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.customerId === customerId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 120,
      field: "Square FrameImage",
      headerName: "Square Frame",
      renderCell: (params) => (
        // params.row.logo ? params.row.logo : "--"
        <div className="flex justify-content-center ">
          <img
            className="img-thumbnail  "
            src={params.row.squareFrameImage}
            alt=""
            width={50}
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "verticalFrameImage",
      headerName: "verticalFrame",
      renderCell: (params) => (
        // params.row.logo ? params.row.logo : "--"
        <div className="flex justify-content-center ">
          <img
            className="img-thumbnail"
            src={params.row.verticalFrameImage}
            alt=""
            width={50}
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      renderCell: (params) => (params.row.name ? params.row.name : "--"),
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "email",
      headerName: "Email",
      renderCell: (params) => (params.row.email ? params.row.email : "--"),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "mobile",
      headerName: "Mobile",
      renderCell: (params) =>
        params.row.mobile
          ? params.row.dialCode + " " + params.row.mobile
          : "--",
    },

    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleCustomerStatusChange(
                params.row.customerId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <Actions
            id={params.row.customerId}
            getDetails={GetCompanyDetails}
            deleteDetails={DeleteCompany}
            removeDelete={orgDetails?.companyLimit > 1}
          />
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingCompanyDetails || isLoadingDelete}
      />

      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.customerId}
        addButton={true}
      />
    </Fragment>
  );
};

export default CustomerDataTableContainer;
